var _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconHeartBeat = function SvgIconHeartBeat(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1 0h24c1.32 1.171 1.32 3.171 0 6s-3.987 5.829-8 9H9c-4-3.333-6.667-6.333-8-9C-.333 3.333-.333 1.333 1 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0078EF",
    fillRule: "nonzero",
    d: "M23.5 2.002c-2.932 0-5.618 1.418-7.178 3.794l-.32.483-.318-.483C14.114 3.418 11.428 2 8.5 2 3.814 2 0 5.654 0 10.147c0 8.259 11.782 17.86 15.392 20.607l.61.463.61-.463C20.218 28.01 32 18.41 32 10.15c0-4.493-3.812-8.147-8.5-8.147zm-15 1.976c2.25 0 4.31 1.084 5.508 2.897L15.996 9.9l2-3.025C19.192 5.062 21.248 3.98 23.5 3.98c3.584 0 6.5 2.766 6.5 6.169 0 2.233-1.114 4.757-2.872 7.321h-4.3l-1.782-3.272a1 1 0 0 0-.876-.52c-.41.018-.702.194-.878.51l-3.17 5.666-2.148-9.12a.999.999 0 0 0-.876-.761 1.013 1.013 0 0 0-1.01.575l-3.17 6.922h-4.05C3.182 15.023 2 12.485 2 10.147c0-3.401 2.916-6.169 6.5-6.169zm7.502 24.74c-1.958-1.534-6.314-5.143-9.654-9.27h3.214c.392 0 .75-.227.912-.581l2.22-4.847 2.07 8.786a.996.996 0 0 0 .974.765c.36 0 .698-.194.876-.51l3.542-6.329 1.194 2.194c.174.32.514.523.88.523h3.434c-2.648 3.3-6.184 6.564-9.662 9.27z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00A989",
    fillRule: "nonzero",
    d: "M20.5-7.998c-2.932 0-5.618 1.418-7.178 3.794l-.32.483-.318-.483C11.114-6.582 8.428-8 5.5-8 .814-8-3-4.346-3 .147c0 8.259 11.782 17.86 15.392 20.607l.61.463.61-.463C17.218 18.01 29 8.41 29 .15c0-4.493-3.812-8.147-8.5-8.147zm-15 1.976c2.25 0 4.31 1.084 5.508 2.897L12.996-.1l2-3.025C16.192-4.938 18.248-6.02 20.5-6.02c3.584 0 6.5 2.766 6.5 6.169 0 2.233-1.114 4.757-2.872 7.321h-4.3l-1.782-3.272a1 1 0 0 0-.876-.52c-.41.018-.702.194-.878.51l-3.17 5.666-2.148-9.12a.999.999 0 0 0-.876-.761 1.013 1.013 0 0 0-1.01.575L5.918 7.47h-4.05C.182 5.023-1 2.485-1 .147c0-3.401 2.916-6.169 6.5-6.169zm7.502 24.74c-1.958-1.534-6.314-5.143-9.654-9.27h3.214c.392 0 .75-.227.912-.581l2.22-4.847 2.07 8.786a.996.996 0 0 0 .974.765c.36 0 .698-.194.876-.51l3.542-6.329 1.194 2.194c.174.32.514.523.88.523h3.434c-2.648 3.3-6.184 6.564-9.662 9.27z",
    mask: "url(#b)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHeartBeat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-heart-beat.3993cde6.svg";
export { ForwardRef as ReactComponent };